import {
  Box,
  Flex,
  Heading,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Square,
  Text,
  Center,
  Img,
  Button,
} from "@chakra-ui/react";
import { generateGridLayout } from "../../helper/helper";
import styles from "./usercard.module.css";
import defaultImage from "Assets/default_image.jpg";
import Custom_Button from "../Recruiter/Button/Custom_Button";
import locationIcon from "Assets/location.svg";
import awardIcon from "Assets/award2.svg";
import { useIntersection } from "hooks/useIntersection";
import { useRef, useState } from "react";
import Badge_Component from "Components/Recruiter/Badge/Badge_Component";
import Swal from "sweetalert2";
import { sendInvite } from "services/api";
import { useSelector } from "react-redux";
import { Login, sendNotification } from "helper/notification";
import { useNavigate } from "react-router-dom";
import emptyState from "Assets/emptyState.png";
import defaultbg from "Assets/bg.png";

export const UserCard = ({ user, data }) => {
  const [isInView, setIsInView] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const posts = useSelector((state) => state.post.data);
  const [selectedJobId, setSelectedJobId] = useState("");
  const finalRef = useRef(null);
  const userData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  // const [randomList, setRandomList] = useState([]);
  const imgRef = useRef();

  useIntersection(imgRef, () => {
    setIsInView(true);
  });

  const projectType = [
    "NFT",
    "3D Environment",
    "Interaction Design",
    "Simulation",
    "Digital twin",
    "Unreal Experience",
  ];

  const modalOpenHandler = () => {
    setModalOpen(true);
  };
  const sendInviteHandler = async (studentId, postId) => {
    try {
      await sendInvite(studentId, postId);
      setModalOpen(false);
      Login({
        name: userData.name,
        room: studentId,
      });
      sendNotification({
        message: `${userData.name} has sent you an invitation`,
        room: studentId,
        username: userData.name,
      });
      Swal.fire({
        icon: "success",
        title: "Invitation Sent..",
        timer: 1300,
      });
    } catch (e) {
      Login({
        name: userData.name,
        room: studentId,
      });
      sendNotification({
        message: `${userData.name} has sent you an invitation`,
        room: studentId,
        username: userData.name,
      });
      Swal.fire({
        icon: "error",
        title: "OOPS! Something went wrong.",
        timer: 1300,
      });
    }
  };

  const filterOnlyImages = () => {
    let filteredData = data?.uploaded?.map((item) => item.url)?.flat();
    let filteredData2 = filteredData?.filter(
      (item) =>
        item?.includes(".png") ||
        item?.includes(".jpg") ||
        item?.includes(".jpeg") ||
        item?.includes(".gif")
    );
    let slicedData =
      filteredData2?.length === 0 ? [emptyState] : filteredData2?.slice(0, 5);
    return slicedData || [""];
  };

  return (
    <SimpleGrid height={494} w={"100%"}>
      <Modal
        finalFocusRef={finalRef}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      >
        <ModalOverlay />
        <ModalContent borderRadius={15} mt={20}>
          <ModalHeader>
            <Heading fontSize={32} fontWeight={600}>
              Select Job Post
            </Heading>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody height={500}>
            <Box>
              {posts?.map((post, idx) => (
                <Box
                  key={post?._id}
                  border="1px solid #E7E6E8;"
                  borderRadius={20}
                  mb={2}
                  onClick={() => setSelectedJobId(post._id)}
                  style={
                    selectedJobId === post._id
                      ? { border: "1px solid #6c56fb" }
                      : {}
                  }
                >
                  <Flex align="center" gap={2} p={4}>
                    <Box>
                      <Square borderRadius={5} size={55} bg="#D9D9D9">
                        {/* logo */}
                        <Img
                          objectFit={"cover"}
                          src={post?.companyID?.profilePhoto}
                          alt="logo"
                        />
                      </Square>
                    </Box>
                    <Box>
                      <Text fontSize={20} fontWeight={600}>
                        {post.jobRoleTitle}
                      </Text>
                      <Text fontSize={16} fontWeight={600}></Text>
                    </Box>
                  </Flex>
                </Box>
              ))}
              {posts?.length === 0 && (
                <Text
                  py={4}
                  fontSize={20}
                  fontFamily={"Roboto"}
                  fontWeight={600}
                  textAlign={"center"}
                >
                  No Active Post
                </Text>
              )}
            </Box>
          </ModalBody>
          <ModalFooter>
            <Center>
              <Flex gap={5} mr={70}>
                <Button
                  border="1px solid #CECCD1"
                  w={118}
                  h={41}
                  py={2}
                  justify="center"
                  borderRadius={12}
                  cursor="pointer"
                  onClick={() => setModalOpen(false)}
                >
                  <Text fontSize={18} fontWeight={600} color="#2C2C2C">
                    Discard
                  </Text>
                </Button>
                <Button
                  _hover={{ bg: "#8E48FF" }}
                  w={118}
                  h={41}
                  py={2}
                  justify="center"
                  bg="#6c56fb"
                  cursor="pointer"
                  borderRadius={12}
                  disabled={selectedJobId === ""}
                  onClick={() => sendInviteHandler(data?._id, selectedJobId)}
                >
                  <Text fontSize={18} fontWeight={500} color="#FFFFFF">
                    Invite
                  </Text>
                </Button>
              </Flex>
            </Center>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Flex>
        <Box
          h="525px"
          bg="white"
          margin={"10px auto"}
          borderRadius="14px"
          w={"100%"}
          border={"1px solid #E7E6E8"}
          overflow={"hidden"}
        >
          <Box>
            <SimpleGrid position={"relative"}>
              <Flex wrap={"wrap"}>
                {generateGridLayout(filterOnlyImages()?.length)?.lg?.map(
                  (item, index) => (
                    <Box
                      height={"110px"}
                      ref={imgRef}
                      border={"1px solid #fff"}
                      w={`${item}%`}
                      style={{
                        borderRadius:
                          filterOnlyImages()?.length === 1
                            ? "10px 10px 0px 0px"
                            : filterOnlyImages()?.length === 2
                            ? index === 0
                              ? "10px 10px 0 0"
                              : "0 0 0 0"
                            : filterOnlyImages()?.length === 3
                            ? index === 0
                              ? "10px 0 0 0"
                              : "0 0 0 0"
                            : filterOnlyImages()?.length === 4
                            ? index === 0
                              ? "10px 0 0 0"
                              : "0 0 0 0"
                            : "0 0 0 0"
                            ? filterOnlyImages()?.length === 5
                              ? index === 0
                                ? "10px 0 0 0"
                                : index === 1
                                ? "0 10px 0 0"
                                : "0 0 0 0"
                              : "0 0 0 0"
                            : "0 0 0 0",

                        height:
                          filterOnlyImages()?.length > 1 ? "100px" : "200px",
                      }}
                      className={styles.image__container}
                      padding={"0px 1px"}
                      // mr={index === 0 ? 2 : 0}
                      marginBottom={0}
                    >
                      {isInView && (
                        <img
                          className={styles.image__background}
                          src={filterOnlyImages()[index]}
                          height={"100%"}
                          onError={(e) => (e.target.src = defaultbg)}
                          loading="lazy"
                          onLoad={(e) => {
                            e.target.style.opacity = 1;
                          }}
                          style={{
                            borderRadius:
                              index === 0
                                ? "10px 0 0 0"
                                : index === 1 && "0 10px 0 0",
                          }}
                          width="100%"
                        />
                      )}
                    </Box>
                  )
                )}
              </Flex>
              <Flex>
                <Box ref={imgRef}>
                  {isInView && (
                    <Image
                      position={"absolute"}
                      bottom={"-12"}
                      left={"36%"}
                      right={"50%"}
                      className={styles.image__profile}
                      borderRadius={"50%"}
                      src={data?.profile_photo || defaultImage}
                      alt="img"
                      onError={(e) => (e.target.src = defaultImage)}
                      width={100}
                      height={100}
                      objectFit={"cover"}
                    />
                  )}
                </Box>
              </Flex>
            </SimpleGrid>
          </Box>
          <Flex
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            mt={16}
          >
            <Text
              fontSize="20px"
              fontWeight="bold"
              _hover={{
                cursor: "pointer",
                color: "#6c56fb",
                textDecoration: "underline",
              }}
              color="black"
              textTransform={"capitalize"}
              onClick={() =>
                navigate(`/hiring/recruiter/studentprofile/${data?._id}`)
              }
            >
              {data?.name}
            </Text>
            <Flex
              height={"20px"}
              fontSize="16px"
              fontWeight="600"
              color="#6C6F74"
              mt={2}
              display={"flex"}
            >
              <h6>
                {data?.jobTitle?.length > 10 && data?.location
                  ? data?.jobTitle?.slice(0, 12) + "..."
                  : data?.jobTitle}
              </h6>{" "}
              {data?.jobTitle?.length > 0 && data?.location && (
                <Text fontSize={15}>&nbsp;|</Text>
              )}
              {data?.location && <img src={locationIcon} />}
              <p> {data?.location}</p>
            </Flex>
            <Flex
              flexDirection={"column"}
              height={"100px"}
              justifyContent={"center"}
              alignItems={"center"}
              w={"100%"}
            >
              {data?.badges?.length > 0 && (
                <Text fontSize="15px" fontWeight="bold" color="black" mt={2}>
                  Badges Earned
                </Text>
              )}
              {data?.badges?.length > 0 &&
                data?.badges
                  ?.sort((a, b) => b - a)
                  ?.slice(0, 1)
                  ?.map((badge, index) => (
                    <Custom_Button
                      centered={true}
                      action={projectType[badge - 1]}
                      fontSize={14}
                      m={"20px 0 0  0px"}
                      color="#7B7E83"
                      cursor={"context-menu"}
                      border={"1px solid #E7E6E8"}
                      isIcon={true}
                      borderRadius={20}
                      w={"50%"}
                      height={"40px"}
                      iconPath={awardIcon}
                      fontWeight={600}
                    />
                  ))}
            </Flex>

            <Custom_Button
              centered={true}
              action={"Invite"}
              bg="#6C56FB"
              color="#fff"
              fontSize={14}
              height={"45px"}
              m={"40px 0px 0px 0px"}
              fontWeight={600}
              w={"70%"}
              fn={() => {
                setModalOpen(true);
              }}
            />
          </Flex>
        </Box>
      </Flex>
    </SimpleGrid>
  );
};
